// components/GenderSelection/GenderSelection.jsx
import React from 'react';
import { Field } from 'formik';
import './GenderSelection.css';
import { User } from 'lucide-react';
import { FormLabel } from '../../profileInfo/components/Forms/GenericInputField/FormLable/FormLabel';

const GenderSelection = ({ name = 'gender', label = 'جنسیت', errors = {}, touched = {}, isDisabled = false, className = '' }) => {
  const hasError = errors[name] && touched[name];

  const options = [
    {
      value: '1',
      label: 'مرد',
    },
    {
      value: '2',
      label: 'زن',
    },
  ];

  return (
    <div className={`gender-selection rtl ${className}`}>
      <FormLabel name={name} label={label} />

      <Field name={name}>
        {({ field }) => (
          <div className='gender-selection__options'>
            {options.map((option, index) => {
              const isSelected = field.value === option.value;
              const optionId = `${name}_${option.value}_${index}`;

              return (
                <div
                  key={option.value || index}
                  className={`gender-selection__option ${isSelected ? 'gender-selection__option--selected' : ''} ${isDisabled ? 'gender-selection__option--disabled' : ''} ${
                    hasError ? 'gender-selection__option--error' : ''
                  }`}
                >
                  <input
                    type='radio'
                    id={optionId}
                    name={field.name}
                    value={option.value}
                    checked={isSelected}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    disabled={isDisabled}
                    className='gender-selection__input'
                  />
                  <label htmlFor={optionId} className={`gender-selection__label ${isDisabled ? 'gender-selection__label--disabled' : ''}`}>
                    {/* آیکون */}
                    {/* <div className='gender-selection__icon'>{option.icon}</div> */}

                    <span className='gender-selection__text'>{option.label}</span>

                    {/* تیک */}
                    <div className='gender-selection__checkmark'>
                      <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                        <path d='M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z' fill='currentColor' />
                      </svg>
                    </div>
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </Field>

      {/* نمایش خطا */}
      {hasError && <div className='gender-selection__error'>{errors[name]}</div>}
    </div>
  );
};

export default GenderSelection;
